export default __webpack_public_path__ + "static/media/TUS.a965a84f.png";